import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Svg } from "../svg/Svg";
export const FontSizeIcon = React.forwardRef((props, ref) => (_jsx(Svg, { "data-testid": "FontSizeIcon", ...props, ref: ref, children: _jsx("path", { fill: "currentColor", d: "M11.527,0V1.524h-5V16H5V1.523H0V0ZM16,4.741V6.265H13.033V16H11.508V6.264H8.542V4.741Z", fillRule: "evenodd" }) })));
FontSizeIcon.displayName = "FontSizeIcon";
